import { render, staticRenderFns } from "./suggestionsContainerAutoSearch.vue?vue&type=template&id=685c1622&scoped=true&"
import script from "./suggestionsContainerAutoSearch.vue?vue&type=script&lang=js&"
export * from "./suggestionsContainerAutoSearch.vue?vue&type=script&lang=js&"
import style0 from "./suggestionsContainerAutoSearch.vue?vue&type=style&index=0&id=685c1622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685c1622",
  null
  
)

export default component.exports